const PortSequenceSelectCustomStyles = {
    option: (provided) => ({
    ...provided,
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
  }),
  }

export { PortSequenceSelectCustomStyles };


const FilterFormSelectCustomStyles = {
  control: (base) => ({
    ...base,
    minHeight: "32px",
    height: "32px",
    fontSize: "0.875rem",
    border: "1px solid #6C757D",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#363636ff",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "30px",
    padding: "0 6px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "30px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 4px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 4px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "0.875rem",
  }),
};

export { FilterFormSelectCustomStyles };


const smallFormSelectCustomStyles = {
  control: (base) => ({
    ...base,
    minHeight: "32px",
    // height: "32px",
    fontSize: "0.875rem",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#363636ff",
  }),
  valueContainer: (base) => ({
    ...base,
    // height: "30px",
    padding: "0 6px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "30px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 4px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 4px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "0.875rem",
  }),
};

export { smallFormSelectCustomStyles };


const centeredFormSelectCustomStyles = {
  control: (base) => ({
    ...base,
    width: "400px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#363636ff",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 6px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 4px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 4px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "0.875rem",
    width: "400px",
  }),
};

export { centeredFormSelectCustomStyles };


